export default "__VITE_ASSET__BZxbQlqB__"